/* eslint-disable react/no-array-index-key */
import { List } from "@mui/material"
import { ReactElement } from "react"
import { useNavigate } from "react-router-dom"

import MobileListItems from "./mobileListItems"
import {
    ApplicationDisplayStatuses,
    ApplicationStatuses,
} from "../../../../constants/enums"
import { DNO_SINGLE_APPLICATION_BASE } from "../../../../router/routes"
import { IApplicationSummary } from "../../../../services/middleware/mappers/dnoInterface/dnoApplicationsMapper"
import MobileListApplicationSkeleton from "../../../loading/skeletons/mobileListApplicationSkeleton"

interface IApplicationListMobileProps {
    searchResults: IApplicationSummary[]
    isEscalations: boolean
    isLoading: boolean
}

const skeletonArray = Array.from({ length: 15 }, () => 0)

/**
 * Mobile friendly list of applications for DNO to review. Users can swipe
 * right to respond to an application
 */
const DnoApplicationListMobile = ({
    searchResults,
    isEscalations,
    isLoading,
}: IApplicationListMobileProps): ReactElement => {
    const navigate = useNavigate()
    return (
        <List sx={{ pt: "0px" }}>
            {isLoading
                ? skeletonArray.map((_, index) => (
                      <MobileListApplicationSkeleton key={index} />
                  ))
                : searchResults.map((application: IApplicationSummary) => {
                      const statusLabel =
                          application.applicationStatus ===
                          ApplicationStatuses.dnoFurtherInfoRequired
                              ? ApplicationDisplayStatuses.installerInformationRequired
                              : application.applicationStatus
                      return (
                          <MobileListItems
                              key={application.applicationId}
                              lcts={application.lcts}
                              title={String(application.applicationId)}
                              subtitle={
                                  isEscalations
                                      ? application.postCode
                                      : statusLabel
                              }
                              subtitleAdditional={
                                  isEscalations
                                      ? application.lcts[0]
                                      : application.postCode
                              }
                              chipText={application.submittedAgo}
                              isUnread={application.isDNOThreadUnread}
                              onClick={() =>
                                  navigate(
                                      `${DNO_SINGLE_APPLICATION_BASE}/${application.applicationId}`
                                  )
                              }
                          />
                      )
                  })}
        </List>
    )
}

export default DnoApplicationListMobile
